"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
exports.Button = function (_a) {
    var ref = _a.ref, onClick = _a.onClick, rounded = _a.rounded, outline = _a.outline, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, children = _a.children, rest = __rest(_a, ["ref", "onClick", "rounded", "outline", "type", "size", "variant", "children"]);
    var className = '';
    if (size === 'sm')
        className += ' btn-sm ';
    if (size === 'lg')
        className += ' btn-lg ';
    if (rounded)
        className += ' rounded ';
    return (react_1.default.createElement("button", __assign({ ref: ref, type: type, className: "btn btn-" + (outline ? 'outline-' : '') + variant + " btn-small " + className, onClick: onClick }, rest), children));
};
//# sourceMappingURL=button.js.map